<template>
  <div class="goods-detail">
    <Header :title="title" :goBackHandler="goBack"></Header>
    <div class="goods-header">
      <div v-if="type==1" class="course-info">
        <div class="content">
          <div class="course-name">{{detail.name}}</div>
          <div class="bottom">
            <span class="integral-wrap">
              <span class="integral">{{detail.exchange_price}}</span>
              <span class="integral-label">{{point_name}}</span>
            </span>
            <span class="num-wrap">
              <span class="sale-num">{{detail.sales_num}}</span>
              <span>人已报名</span>
              <span class="line">|</span>
              <span>剩余</span>
              <span class="stock">{{detail.surplus}}</span>
              <span>名额</span>
            </span>
          </div>
        </div>
        <div class="line-hor"></div>
      </div>
      <div v-else class="book-info">
        <img class="cover" :src="detail.cover_img" />
        <div class="right">
          <div>
            <div class="book-name">{{detail.name}}</div>
            <span class="num-wrap">
              <span class="sale-num">{{detail.sales_num}}</span>
              <span>人已报名</span>
              <span class="line">|</span>
              <span>剩余</span>
              <span class="stock">{{detail.surplus}}</span>
              <span>名额</span>
            </span>
          </div>
          <div class="integral-wrap">
            <span class="integral">{{detail.exchange_price}}</span>
            <span class="integral-label">{{point_name}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-wrap">
      <div class="title">{{type==1?"课程详情":"图书介绍"}}</div>
      <div class="detail" v-html="detail.intro"></div>
    </div>
    <div :class="{'show-address':showAddress}" class="btn-wrap">
      <router-link
        v-if="detail.is_check!=2||type==2"
        :to="{name:type==1?'CourseDetail':'BookDetail',query:{id:detail.goods_id}}"
      >查看详细信息</router-link>
      <a
        v-if="detail.is_check!=2||type==2"
        :class="{'disabled':detail.surplus==0}"
        @click="tryExchange"
      >立即兑换</a>
      <a v-if="detail.is_check==2&&type==1" class="study" @click="joinStudy">立即学习</a>
    </div>
    <van-action-sheet class="sheet" v-model="showAddress" title="收货地址">
      <div class="address">
        <img class="add-img" src="@/assets/images/book/address.png" alt />
        <div class="add-info" v-if="address.is_default">
          <p class="add-userinfo">
            <span>{{address.user_name}}</span>
            <font>{{address.mobile}}</font>
          </p>
          <p
            class="add-province"
          >{{address.province_name+address.city_name+address.district_name+address.address}}</p>
        </div>
        <div class="add-choose" @click="chooseAddress" v-else>
          <img src="@/assets/images/book/pay-address.png" alt />
        </div>
        <i class="add-go" @click="chooseAddress" v-if="address.is_default"></i>
      </div>
      <div :class="{'show-address':showAddress}" class="btn-wrap">
        <a @click="showAddress=false">取消</a>
        <a @click="tryExchange">立即兑换</a>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import Header from "@/components/Header";
export default {
  name: "IntegralGoodsDetail",
  components: {
    Header
  },
  data() {
    return {
      title: {
        name: "兑换商品"
      },
      id: this.$route.params.id,
      type: this.$route.query.type,
      detail: {},
      showAddress: false,
      address: {}
    };
  },
  async created() {
    this.detail = await this.$http.get("/api/integral/shop/detail/" + this.id);
    this.detail.surplus = this.detail.stock - this.detail.sales_num;
    if (this.type == 2) {
      let address_id = this.$store.state.pay_address_id;
      this.$store.commit("SET_PAY_ADDRESS"); //清除
      if (address_id) {
        this.address = await this.$http.get(`/api/app/address/${address_id}`);
        this.showAddress = true;
      } else {
        this.getAddress();
      }
    }
    document.title = this.point_name + "商品详情";
  },
  computed: {
    point_name() {
      if(this.$store.state.config){
        return this.$store.state.config.point_info.point_name
      } else{
        return '';
      };
    }
  },
  watch: {
    point_name(val) {
      document.title = val + "商品详情";
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1);
    },
    async getAddress() {
      let address_list = await this.$http.get("/api/app/address");
      address_list.length &&
        address_list.forEach(item => {
          if (item.is_default == 1) {
            this.address = item;
          }
        });
    },
    chooseAddress() {
      this.$router.push({
        name: "Address",
        query: {
          payChoose: 1
        }
      });
    },
    async exchange() {
      let data = {
        shop_id: this.detail.goods_id,
        product_number: 1,
        integral_id: this.id
      };
      if (this.detail.goods_type == 1) {
        data.type = this.detail.course_type;
      } else {
        data.type = 12;
        data.address_id = this.address.id;
      }
      await this.$http.post("/api/app/order/downOrder", data);
      this.$toast("兑换成功");
      this.$router.push({ name: "IntegralRecord" });
    },
    async tryExchange() {
      if (this.detail.surplus == 0) {
        this.$toast("剩余名额不足");
        return;
      }
      if (this.type == 1) {
        await this.exchange();
      } else {
        if (!this.address.id || !this.showAddress) {
          if (this.showAddress) {
            this.$toast("请选择收货地址");
          } else {
            this.showAddress = true;
          }
        } else {
          await this.exchange();
        }
      }
    },
    async joinStudy() {
      await this.$http.post("/api/app/joinStudy", {
        course_basis_id: this.detail.goods_id,
        join_from: 3,
        course_type: this.detail.course_type
      });
      this.$router.push({ name: "MyStudy" });
    }
  }
};
</script>
<style lang="scss" scoped>
.course-info {
  border-top: 1px solid #f5f5f5;
  .content {
    padding: 38px 30px 60px 30px;
  }
  .course-name {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 60px;
    margin-bottom: 40px;
  }
  .bottom {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .line-hor {
    height: 20px;
    background: rgba(247, 248, 250, 1);
  }
}
.integral-wrap {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(238, 31, 31, 1);
  line-height: 30px;
  .integral {
    font-size: 32px;
  }
  .integral-label {
    font-size: 24px;
  }
}
.num-wrap {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(140, 140, 140, 1);
  line-height: 24px;
  .sale-num {
    margin-right: 8px;
  }
  .line {
    margin: 0 8px;
  }
  .stock {
    margin: 0 8px;
  }
}
.detail-wrap {
  padding: 40px 30px 0 30px;
  margin-bottom: 138px;
  font-size: 32px;
  .title {
    height: 50px;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 50px;
    margin-bottom: 20px;
  }
  .detail{
    /deep/{
      img{
        max-width: 100%;
      }
    }
  }
}
.btn-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  text-align: center;
  padding: 12px 0;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.07);
  a {
    width: 346px;
    height: 74px;
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 74px;
    text-align: center;
    display: inline-block;
    &:first-child {
      background-color: $theme_color_light;
      color: $theme_color;
      border-radius: 38px 0px 0px 38px;
    }
    &:last-child {
      background-color: $theme_color;
      color: white;
      border-radius: 0px 38px 38px 0px;
    }
    &.study {
      width: 690px;
      border-radius: 38px;
    }
    &.disabled {
      cursor: not-allowed;
      color: #fff;
      background-color: #a0cfff;
    }
  }
}
.book-info {
  display: flex;
  padding: 60px;
  .cover {
    width: 206px;
    height: 288px;
    box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.4);
    margin-right: 30px;
  }
  .book-name {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 48px;
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.address-modal {
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 98px;
}
.goods-detail {
  /deep/ {
    .van-overlay {
      height: calc(100vh - 98px);
    }
  }
}
.sheet {
  .btn-wrap {
    position: static;
    box-shadow: none;
  }
  /deep/ {
    .van-action-sheet__header {
      font-size: 34px;
      color: #262626;
      font-weight: 400;
      &::after {
        border: none;
      }
      .van-icon-close {
        width: 30px;
        height: 30px;
        line-height: 30px;
        padding: 0;
        right: 30px;
        top: 32px;
        display: inline-block;
        background-image: url("~@/assets/images/close@2x.png");
        background-size: 100% 100%;
        &::before {
          display: none;
        }
      }
    }
  }
}
.address {
  display: flex;
  align-items: center;
  background: #fff;
  margin-top: 20px;
  min-height: 138px;
  border-radius: 20px;
  .add-img {
    width: 58px;
    height: 58px;
    margin-left: 30px;
    flex: none;
  }
  .add-info {
    flex: 1;
    margin-left: 20px;
    .add-userinfo {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      padding-bottom: 6px;
      span {
        font-size: 28px;
        color: rgba(32, 36, 42, 1);
      }
      font {
        padding-left: 10px;
        font-size: 24px;
        color: rgba(140, 140, 140, 1);
      }
    }
    .add-province {
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(32, 36, 42, 1);
      line-height: 30px;
      padding-bottom: 12px;
    }
  }
  .add-choose {
    flex: 1;
    margin-left: 20px;
    img {
      margin-top: 10px;
      width: 218px;
      height: 42px;
    }
  }
  .add-go {
    flex: none;
    width: 60px;
    height: 168px;
    background: url("~@/assets/images/book/purchase.png") no-repeat center
      center;
    background-size: 18px 30px;
  }
}
</style>
